import React, { useState } from 'react'
import axios from 'axios'
import { List, Box, Typography, Input, TableContainer, Table, TableHead, TableBody, TableRow, Paper, Pagination, Button, Rating, Menu, Radio, RadioGroup, FormControl, FormControlLabel, Modal, MenuItem, Divider, Select,Snackbar,CircularProgress,Alert} from '@mui/material'
import { useRedirect } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import legolasApi from '../../api/legolas'
import { useNavigate } from 'react-router-dom'
import ChannelDropDown from '../common/ChannelDropDown';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { useForm, Controller } from 'react-hook-form'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function ProductReview() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [totalCount, setTotalcount] = React.useState(0)
  const [listData, setListData] = React.useState([])
  const [searchString, setSearchstring] = React.useState('')
  const [currentPage, setCurrentPage] = React.useState(1)
  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: 'userName', label: 'Name', checked: true },
    { id: 'reviewEmailId', label: 'Email', checked: true },
    { id: 'item_name', label: 'Product Name', checked: true },
    { id: 'rating', label: ' Rating', checked: true },
    { id: 'reviewTitle', label: 'Review Title', checked: true },
    { id: 'reviewDescription', label: 'Review Description ', checked: true },
    { id: 'S3Uploaded', label: 'Image Uploaded', checked: true },
    // { id: 'adminApproved', label: 'Status', checked: true },
    { id: 'createdAt', label: 'Review Created ', checked: true },
    {id: 'channelName',label:'Channel',checked: true}

  ])
  const [channelData, setChannelData] = React.useState([]);
  const [filterValue, setFilterValue] = React.useState('');
  const [exportFormat, setExportFormat] = useState('csv');
  const [filterArray, setFilterArray] = React.useState([])
  const [openFilters, setOpenFilters] = React.useState(false)
  const [adminApprovedStatus, setAdminApprovedStatus] = useState('');
  const [selected, setSelected] = React.useState([]);
  const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null });
  const [loading, setLoading] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false);
  const [adminApproved, setAdminApproved] = React.useState(true);
  const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
  const userid = user.id
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const userIds = [143];
  const adminRoleId = user.admin_role_id;
  const [reviewData, setReviewData] = React.useState({});
  const [selectedValue, setSelectedValue] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [currentReviewId, setCurrentReviewId] = useState(null); // Track the current review for confirmation

  const redirect = useRedirect()
  const navigate = useNavigate()

  const [reviewStatus, setReviewStatus] = React.useState(
    {
    Pending: 'Pending',
    Approved: 'Approved',
    Disapproved: 'Disapproved',
  },
  )

  const  getdetails = (reviewId) =>{
    axios.get(`${legolasApi.url}/product/review/detailedReview/${reviewId}`).then((res) => {
        if(res.data && res.status){
          const reviewData = res.data.data;

          if (res.data.data.adminApproved !== undefined) {
            setAdminApproved(res.data.data.adminApproved);
          }
            setReviewData(reviewData)
        }
       
    }).catch((error) => {
        console.error("Error fetching review data:", error);
      });
 }

 React.useEffect(() => {
   getdetails();
  }, []);



 const handleUpdate = (reviewId, adminApprovedStatus) => {
  if (!reviewId) {
    console.error('Review id is undefined');
    return;
  }

  let valuesData = {
    adminApproved: adminApprovedStatus, 
  };

  axios.post(`${legolasApi.url}/product/review/adminapproved/${reviewId}`, valuesData)
    .then((res) => {
      console.log("Update response:", res);
      if (res.data && res.status) {
        handleAlertGen();  // Trigger success alert
        setListData((prevListData) =>
          prevListData.map((review) =>
            review._id === reviewId
              ? { ...review, adminApproved: adminApprovedStatus }
              : review
          )
        );
      }
    })
    .catch((error) => {
      console.error("Error updating review data:", error);
    })
    .finally(() => {
      setIsLoading(false);
    });
};

  const handleSwitchChange = (reviewId, event) => {
    const selected = event.target.value;
    setSelectedValue(selected); 
    setCurrentReviewId(reviewId); // Set the current review ID
    setModalOpen(true); // Open the confirmation modal
  };

  const handleUserAction = () => {
    setIsLoading(true); 
    handleUpdate(currentReviewId, selectedValue); 
    setModalOpen(false); 
  };

  const handleClosed = () => {
    setModalOpen(false); // This should close the modal
  };

const handleAlertGen = () => {
    setOpenAlert(true);  
 }

 const closeAlert = () => {
   setOpenAlert(false);
 }
  const getChannel = () => {
    axios.get(`${legolasApi.url}/admin/channel/list`)
      .then((res) => {
        console.log('order res: ', res.data.data);
       // setChannelData(res.data.data);
        const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
      })
      .catch((error) => console.log('Error in getting orders: ', error));
  }
const buildChannelParam = (selectedChannel) => {
  if (selectedChannel) {
    return { filter: selectedChannel }; // user-selected
  }
  if (userChannels.length > 0) {
    return { filter: userChannels.length === 1 ? userChannels[0] : userChannels.join(',') };
  }
  return {}; // fallback
};

const handleFilter = (field, value) => {
  let selectedChannel = filterValue;
  let newStatus = [...filterArray];

  if (field === 'channel') {
    selectedChannel = value || '';
    setFilterValue(selectedChannel);
  } else if (field === 'status') {
    newStatus = [value];
    setFilterArray(newStatus);
    setAdminApprovedStatus(value);
  }

  const channelParam = buildChannelParam(selectedChannel);

  const filterQuery = {
    ...channelParam,
    status: newStatus,
    adminApproved: value
  };

  setLoading(true);

  axios.get(`${legolasApi.url}/product/review/list`, { params: filterQuery })
    .then((res) => {
      setListData(res.data.data.data);
      setTotalcount(res.data.data.count);
      setOpenFilters(false);
    })
    .catch((error) => console.log('Error in getting reviews: ', error))
    .finally(() => setLoading(false));
};

const handlePagination = (event, value) => {
  const offset = value - 1;
  const selectedChannel = filterValue;
  const channelParam = buildChannelParam(selectedChannel);

  const params = {
    offset,
    ...channelParam,
    status: filterArray,
    adminApproved: adminApprovedStatus,
    fromDate: dateRange.fromDate ? moment(dateRange.fromDate).format('YYYY-MM-DD') : null,
    toDate: dateRange.toDate ? moment(dateRange.toDate).format('YYYY-MM-DD') : null,
  };

  setLoading(true);
  axios.get(`${legolasApi.url}/product/review/list`, { params })
    .then((res) => {
      setCurrentPage(value);
      setListData(res.data.data.data);
    })
    .catch((error) => console.log('Error in getting reviews: ', error))
    .finally(() => setLoading(false));
};

const handleSearch = () => {
  const selectedChannel = filterValue;
  const channelParam = buildChannelParam(selectedChannel);

  if (searchString?.length > 0) {
    const params = {
      search: searchString,
      ...channelParam,
      adminApproved: adminApprovedStatus
    };

    setLoading(true);
    axios.get(`${legolasApi.url}/product/review/list`, { params })
      .then((res) => {
        setListData(res.data.data.data);
        setTotalcount(res.data.data.count);
      })
      .catch((error) => console.error('Error fetching data:', error))
      .finally(() => setLoading(false));
  }
};

const handleFilters = (field, value) => {
  let selectedChannel = filterValue;
  let newDateRange = { ...dateRange };

  if (field === 'channel') {
    selectedChannel = value || '';
  } else if (field === 'dateRange') {
    newDateRange = {
      fromDate: value.fromDate,
      toDate: value.toDate
    };
  }

  setFilterValue(selectedChannel);
  setDateRange(newDateRange);

  const channelParam = buildChannelParam(selectedChannel);

  const params = {
    ...channelParam,
    fromDate: newDateRange.fromDate ? moment(newDateRange.fromDate).format('YYYY-MM-DD') : null,
    toDate: newDateRange.toDate ? moment(newDateRange.toDate).format('YYYY-MM-DD') : null,
  };

  setLoading(true);
  axios.get(`${legolasApi.url}/product/review/list`, { params })
    .then((res) => {
      setListData(res.data.data.data);
      setTotalcount(res.data.data.count);
    })
    .catch((error) => console.log('Error in getting coupons: ', error))
    .finally(() => setLoading(false));
};

React.useEffect(() => {
  getChannel();

  const channelParam = buildChannelParam(); // fallback to userChannels

  axios.get(`${legolasApi.url}/product/review/list`, {
    params: {
      ...channelParam
    }
  })
    .then((res) => {
      const data = res.data.data.data;
      const count = res.data.data.count;
      setListData(data);
      setTotalcount(count);
    })
    .catch((error) => console.log('Error in getting reviews: ', error));
}, []);


  const handleViewPage = (review) => {
    console.log("orders", review._id)
    const redirectUrl = `/product/detailedreview/${review._id}`
    navigate(redirectUrl)
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }


  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchAllData = async (filterValue, dateRange) => {
    try {
      const { fromDate, toDate } = dateRange;
          const channelParam = buildChannelParam(filterValue);

      const res = await axios.get(`${legolasApi.url}/product/review/list`, {
        params: {
          limit: 20000,
          filter: filterValue,
          fromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
          toDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
          //channels: userChannels.join(',') // ✅ Inject userChannels
           ...channelParam 
        }
        });
      return res.data.data.data;
    } catch (error) {
      console.error('Error fetching all data: ', error);
      return [];
    }
  };

  const escapeXML = (unsafe) => {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };


  const handleExport = async () => {
  setAnchorEl(null);
  try {
    const channelParam = buildChannelParam(filterValue);

    const filterQuery = {
      ...channelParam,
      status: filterArray,
      adminApproved: adminApprovedStatus,
      fromDate: dateRange.fromDate ? moment(dateRange.fromDate).format('YYYY-MM-DD') : null,
      toDate: dateRange.toDate ? moment(dateRange.toDate).format('YYYY-MM-DD') : null,
      limit: 20000   // bigger limit for export
    };

    const res = await axios.get(`${legolasApi.url}/product/review/list`, { params: filterQuery });
    const allData = res.data.data.data;

    if (exportFormat === 'csv') {
      exportToCSV(allTableHeaders, allData);
    } else if (exportFormat === 'excel') {
      exportToXML(allTableHeaders, allData);
    }
  } catch (error) {
    console.error('Error in exporting reviews: ', error);
  }
};

  const exportToCSV = (headers, data, fileName = 'data.csv') => {
    const csvRows = [];
    // Add headers to CSV
    const headerRow = headers.map(header => header.label).join(',');
    csvRows.push(headerRow);
    // Add data to CSV
    data.forEach(row => {
      const rowValues = headers.map(header => {
        const value = row[header.id];
        return `"${value !== undefined ? value : ''}"`; // Handle undefined values
      });
      csvRows.push(rowValues.join(','));
    });
    // Create a blob from the CSV string and trigger download
    const csvString = csvRows.join('\n');
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportToXML = (headers, data, fileName = 'data.xml') => {
    let xmlString = '<?xml version="1.0" encoding="UTF-8"?>\n<data>\n';
    data.forEach(row => {
      xmlString += '  <row>\n';
      headers.forEach(header => {
        const value = row[header.id] ? escapeXML(row[header.id].toString()) : '';
        xmlString += `    <${header.id}>${value}</${header.id}>\n`;
      });
      xmlString += '  </row>\n';
    });
    xmlString += '</data>';
    // Create a blob from the XML string and trigger download
    const blob = new Blob([xmlString], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleCancel = () => {
    setOpenFilters(false);
  };

  const clearFilterArray = () => {
    setFilterArray([]);
  }

  const handleFromDateChange = (date) => {
    setDateRange((prev) => ({ ...prev, fromDate: date }));
    handleFilters('dateRange', { fromDate: date, toDate: dateRange.toDate });
  };
  const handleToDateChange = (date) => {
    setDateRange((prev) => ({ ...prev, toDate: date }));
    handleFilters('dateRange', { fromDate: dateRange.fromDate, toDate: date });
  };

  const ReviewFilters = () => {
    const { control } = useForm({
      defaultValues: {
        status: null,
      },
    });
    return (
      <Box>
        <Typography variant='body1'>Apply Filters</Typography>
        {/* <Box component="form" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap'}}> */}
        {/* Status Filter */}
        <Box sx={{ flex: '1 1 auto', minWidth: '200px' }}>
          <Typography variant='body1'></Typography>
          <Controller
            name='status'
            control={control}
            defaultValue=''
            render={({ field: { value, onChange } }) =>
              <Select
                label='Select Status'
                value={value || ''}
                onChange={(e) => {
                  onChange(e.target.value);
                  handleFilter('status', e.target.value);
                }}
                sx={{ width: '100%', borderRadius: '4px', border: '1px solid #000' }}
              >
                <MenuItem value=''>Select Review Status</MenuItem>
                {Object.entries(reviewStatus).map(([key, value]) => (
                  <MenuItem key={key} value={key}>{value}</MenuItem>
                ))}
              </Select>
            }
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            margin: '10px 20px',
            justifyContent: 'space-between !important',
            width: '100%',
          }}
        >
          <Button
            onClick={handleCancel}
            sx={{
              textTransform: 'capitalize',
              color: 'primary.main',
              marginLeft: 'auto',
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    );

  }

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Review</Typography>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              {totalCount} record(s) found
            </Typography>
          </Box>
        </Box>

        <Box sx={globalStyles.headerWrapperBox}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              margin: '0px 30px',
              '& .MuiInput-input': {
                width: '300px !important',
                padding: '5px 10px !important',
              },
              '& .MuiSvgIcon-root': {
                paddingRight: '10px',
              },
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ flex: '1 1 auto' }}>

            <Input
              type='search'
              sx={{
                border: '1px solid #2b3f7a',
                borderRadius: '20px',
                height: '40px',
                marginTop: '20px',
              }}
              endAdornment={
                <SearchIcon
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleSearch()}
                />
              }
              placeholder='Search by Email Id'
              onChange={(e) => setSearchstring(e.target.value)}
            />
            </Box>
             <Box style={{marginRight:"15%",marginRight: '1%'}}>
                 { userChannels.length > 1 && ( <ChannelDropDown  channelData={channelData} handleChannelFilter={handleFilters}/> )}
              </Box> 
              <Box sx={{ flex: '1 1 auto', minWidth: '100px', marginRight: '27px' }}>
              <Typography variant='body1' sx={{ marginBottom: '2px', fontSize: '14px', color: 'rgb(128, 128, 128)' }}>Filter by Date Range</Typography>
              <Box sx={{ display: 'flex', gap: '7px', marginRight: '80px' }}>
                <DatePicker
                  selected={dateRange.fromDate}
                  onChange={handleFromDateChange}
                  selectsStart
                  startDate={dateRange.fromDate}
                  endDate={dateRange.toDate}
                  isClearable
                  placeholderText="From Date"
                />
                <DatePicker
                  selected={dateRange.toDate}
                  onChange={handleToDateChange}
                  selectsEnd
                  startDate={dateRange.fromDate}
                  endDate={dateRange.toDate}
                  minDate={dateRange.fromDate}
                  isClearable
                  placeholderText="To Date"
                />
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                width: 'auto',
                textAlign: 'end',
                '& .MuiButton-sizeSmall': {
                  lineHeight: '30px !important',
                },
                '& .MuiDivider-root': {
                  borderRightWidth: 'thin !important',
                  borderColor: '#2b3f7a',
                },
              }}
            >
              <Button sx={globalStyles.listSubheaderIcons} onClick={() => setOpenFilters(true)}>
                <FilterAltIcon /> Filters{' '}
                <Divider
                  orientation='vertical'
                  flexItem
                  sx={{ padding: '0px 10px' }}
                />
              </Button>
              <Modal
                open={openFilters}
                onClose={() => setOpenFilters(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <Box sx={globalStyles.modalContainer}>
                  <ReviewFilters />
                </Box>
              </Modal>

              <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                <FileUploadIcon /> Export{' '}
                <ArrowDropDownIcon
                  sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }}
                />
              </Button>
              <Menu
                id='basic-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                sx={{ padding: 2, borderRadius: 1, boxShadow: 3 }}

              >
                <FormControl component="fieldset" sx={{ padding: 2 }}>
                  <RadioGroup
                    aria-labelledby='demo-radio-buttons-group-label'
                    name='export-options'
                    value={exportFormat}
                    onChange={(e) => setExportFormat(e.target.value)}
                  >
                    <FormControlLabel
                      value='csv'
                      control={<Radio size='small' />}
                      label='CSV'
                      sx={{ marginBottom: 1 }}

                    />
                    <FormControlLabel
                      value='excel'
                      control={<Radio size='small' />}
                      label='Excel XML'
                      sx={{ marginBottom: 1 }}

                    />
                  </RadioGroup>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                    <Button onClick={handleClose} sx={{ textTransform: 'none', color: 'error.main' }}>Cancel</Button>
                    <Button onClick={handleExport} variant="contained"
                    sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}>Export</Button>
                  </Box>
                </FormControl>
              </Menu>
            </Box>
          </Box>
        </Box>

        <Box sx={{ margin: '20px 30px' }}>
          {console.log('filterArray value', filterArray)}
          {filterArray.length !== 0 ? 'Filters: ' : ''}
          {filterArray.map((filter) => {
            if (filter !== '') {
              return (
                <Typography variant='' sx={{ margin: '20px 30px' }} key={filter}>
                  Status: {reviewStatus[filter]}
                  <CancelIcon
                    sx={{ fontSize: '15px', cursor: 'pointer', color: '#2b3f7a' }}
                    onClick={() => clearFilterArray()}
                  />
                </Typography>
              )
            }
          })}
          
        </Box>
        <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
            <TableHead sx={{
              backgroundColor: globalStyles.colors.backgroundPrimary,
              height: '40px !important',
              borderRadius: '0 !important',
              '& .MuiTableCell-root': {
                color: '#fff !important',
                padding: '10px !important',
                borderRight: '2px solid #fff !important',
                borderRadius: '0 !important'
              }
            }}>
              <TableRow>
                {allTableHeaders.map((header) => {
                  if (header.checked) {
                    return (
                      <StyledTableCell align='center'>{header.label}</StyledTableCell>
                    )
                  }
                })}
                <StyledTableCell align='center'>Action / Status</StyledTableCell>
                <StyledTableCell align='center'>View</StyledTableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {listData?.map((review, key) => {
                return (
                  <StyledTableRow id={key} key={review._id}>
                    {allTableHeaders.map((header) => {
                      if (header.checked) {
                        if (header.id === 'userName') {
                          return (
                            <StyledTableCell>
                              {review[header.id] ? (review[header.id].length > 20
                                ? `${review[header.id].substring(0, 20)}...`
                                : review[header.id])
                                : (
                                  '')}
                            </StyledTableCell>
                          )
                        }

                        else if (header.id === 'reviewEmailId') {
                          return (
                            <StyledTableCell align='center'>
                              {review.userId === null ? review[header.id] + " (Guest User)" : review[header.id]}
                            </StyledTableCell>
                          )
                        }
                        else if (header.id === 'item_name') {
                          return (
                            <StyledTableCell align='center'>

                              {review[header.id] ? review[header.id] : ''}
                            </StyledTableCell>
                          )
                        }
                        else if (header.id === "rating") {
                          return (
                            <StyledTableCell align='center'>
                              <Rating name="read-only" value={review[header.id]} precision={0.5} readOnly />
                            </StyledTableCell>
                          )
                        }
                        else if (header.id === "reviewTitle") {
                          return (
                            <StyledTableCell align='center'>
                              {/* {review[header.id]} */}
                              {review[header.id] ? (review[header.id].length > 30
                                ? `${review[header.id].substring(0, 30)}...`
                                : review[header.id])
                                : (
                                  '')}
                            </StyledTableCell>
                          )
                        }
                        else if (header.id === "reviewDescription") {
                          return (
                            <StyledTableCell align="center">
                              {review[header.id] ? (
                                review[header.id].length > 30 ? (
                                  <>
                                    {review[header.id].substring(0, 30)}
                                    <span style={{ fontSize: '1.2rem' }}>...</span>
                                  </>
                                ) : (
                                  review[header.id]
                                )
                              ) : (
                                'NA'
                              )}
                            </StyledTableCell>
                          );
                        }
                        else if (header.id === "adminApproved") {
                          return (
                            <StyledTableCell align='center'>
                              {review[header.id]}
                            </StyledTableCell>
                          )
                        }
                        else if (header.id === "S3Uploaded") {
                          return (
                            <StyledTableCell align='center'>
                              {review[header.id] === true ? "Uploaded" : "Not Uploaded"}
                            </StyledTableCell>
                          );
                        }
                        else if (header.id === "createdAt") {
                          return (
                            <StyledTableCell align='center'>
                              {formatDateAndTime(new Date(review[header.id]))}
                            </StyledTableCell>
                          )
                        }
                        else {
                          return (
                            <StyledTableCell align='center'>
                              {review[header.id]}
                            </StyledTableCell>
                          )
                        }
                      }
                    })}
                    <StyledTableCell align='center'>
                      <Box sx={{ width: '100%', height: 'auto', marginTop: '10px' }}>
                        {/* Snackbar for success message */}
                        <Snackbar
                          open={openAlert}
                          autoHideDuration={4000}
                          onClose={closeAlert}
                          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                          <Alert
                            onClose={closeAlert}
                            severity="success"
                            sx={{ width: '400px', marginTop: '100px' }}
                          >
                            Status has been Changed Successfully
                          </Alert>
                        </Snackbar>

                        {/* Loading spinner */}
                        {isLoading && (
                          <CircularProgress
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                            }}
                            size={40}
                            thickness={4}
                            color="primary"
                          />
                        )}

                        {/* Modal for confirmation */}

                        <Modal
                          open={modalOpen}
                          onClose={handleClosed}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          BackdropProps={{
                            style: { display: 'none' },
                          }}
                        >
                          <Box sx={{
                            ...globalStyles.modalContainer,
                            boxShadow: 'none',
                          }}>

                            <Typography id="modal-modal-title" variant="h6" component="h2">
                              Are you sure you want to change the status to {selectedValue}?
                            </Typography>
                            <Box sx={{
                              display: 'flex', justifyContent: 'end', marginTop: '20px',
                              '& .MuiButton-root': {
                                color: globalStyles.colors.backgroundPrimary,
                                textTransform: 'capitalize'
                              }
                            }}>
                              <Button onClick={handleClosed}>Cancel</Button>
                              <Button onClick={handleUserAction}>OK</Button>
                            </Box>
                          </Box>
                        </Modal>
                        {/* Radio Group for status selection */}
                        <Box sx={{ marginLeft: '25px', marginTop: '1px', width: '15%' }}>
                          <RadioGroup
                            value={review.adminApproved}
                            onChange={(event) => handleSwitchChange(review._id, event)}
                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}

                          >
                            <FormControlLabel
                              value="Approved"
                              control={<Radio size="small" sx={{ padding: '2px' }} />}
                              label="Approved"
                              sx={{ fontSize: '0.8rem', marginLeft: '2px', transform: 'scale(0.8)' }}

                            />
                            <FormControlLabel
                              value="Disapproved"
                              control={<Radio size="small" sx={{ padding: '2px' }} />}
                              label="Disapproved"
                              sx={{ fontSize: '0.8rem', marginLeft: '0', transform: 'scale(0.8)' }}

                            />
                            <FormControlLabel
                              value="Pending"
                              control={<Radio size="small" sx={{ padding: '2px' }} />}
                              label="Pending"
                              sx={{ fontSize: '0.8rem', marginLeft: '2px', transform: 'scale(0.8)' }}

                            />
                          </RadioGroup>
                        </Box>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell align='center'>
                      <Button onClick={() => handleViewPage(review)} >View</Button>
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ justifyContent: 'center' }}>
          <Pagination count={Math.ceil(totalCount / 20)} page={currentPage} onChange={handlePagination} />
        </Box>
      </List>
    </React.Fragment>
  )
}

export default ProductReview;


